const viewport = {
  once: true
}

const initial = {
  hidden: {
    opacity: 0,
    y: 50
  }
}

const visible = {
  opacity: 1,
  y: 0
}

export const AnimationConfig = {
  variants: {
    visible,
    initial
  },
  viewport
}
